export default class Header {
	constructor() {

		this.section = document.querySelector('header')
		this.btnParques = this.section.querySelector('.btn-parques')
		this.btnResorts = this.section.querySelector('.btn-resorts')
		this.btnMenuMobile = this.section.querySelector('#btnMenuMobile')

		this.menu = this.section.querySelector('.line-white .menus')
		this.menuCinza = this.section.querySelector('.line-grey')
		this.menuLaranja = this.section.querySelector('.line-two')

		this.sectionSubMenu = this.section.querySelectorAll('.line-grey .subMenu')
		this.parquesSubMenu = this.section.querySelector('.line-grey #sub-menu-parques')
		this.resortsSubMenu = this.section.querySelector('.line-grey #sub-menu-resorts')
		
		this.btnAccessibility = document.querySelector('.toggle-accessibility')
		this.accessibilityOption = this.btnAccessibility.querySelector('.options')

		this.btnVoltarSubMenu = this.section.querySelector('.btnVoltarMenuMobile')

		this.ready();
		this.sanitizeSearchInput();
	}
	ready() {

		this.btnParques.addEventListener('click', () => {

			this.resortsSubMenu.classList.remove('active')

			if(this.parquesSubMenu.classList.contains('active')) {
				this.parquesSubMenu.classList.remove('active')
				this.menuLaranja.classList.remove('subMenuActive')
			} else {
				this.parquesSubMenu.classList.add('active')
				this.menuLaranja.classList.add('subMenuActive')
			}

			if(this.btnMenuMobile.classList.contains('active')) {
				this.menuCinza.classList.add('activeLine')
			}

		})
		
		this.btnResorts.addEventListener('click', () => {

			this.parquesSubMenu.classList.remove('active')

			if(this.resortsSubMenu.classList.contains('active')) {
				this.resortsSubMenu.classList.remove('active')
				this.menuLaranja.classList.remove('subMenuActive')
			} else {
				this.resortsSubMenu.classList.add('active')
				this.menuLaranja.classList.add('subMenuActive')
			}

			if(this.btnMenuMobile.classList.contains('active')) {
				this.menuCinza.classList.add('activeLine')
			}

		})

		//Botao Voltar SubMenu no Mobile
		if(this.btnVoltarSubMenu) {
			this.btnVoltarSubMenu.addEventListener('click', () => {
				this.menuCinza.classList.remove('activeLine')
				this.resortsSubMenu.classList.remove('active')
				this.parquesSubMenu.classList.remove('active')
				this.menuLaranja.classList.remove('subMenuActive')
			})
		}

		//Menu Mobile
		if(this.btnMenuMobile) {
			this.btnMenuMobile.addEventListener('click', () => {
				this.btnMenuMobile.classList.toggle('active')
				this.menuLaranja.classList.toggle('active')
				this.menu.classList.toggle('active')
			})
		}

		this.btnAccessibility.addEventListener('click', () => {
			this.accessibilityOption.classList.toggle('active')
		})

	}

	sanitizeSearchInput() {

		const searchInputs = document.querySelectorAll('.searchField')
		searchInputs.forEach(el => {
			el.addEventListener('input', () => {
				el.value = el.value.replace(/[^a-zA-Z0-9\s]/g, '');
			})
		})

	}
}